import { FEATURE_CINECLUB_DATE } from "lacinetek-common/src/metadata"
const club = {
	metadata: [{name: FEATURE_CINECLUB_DATE, value: "12 juin 2012"}],
	products: { items: [] }
}

export default {
	children: { items: [club, club] }
}
